// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import React, { FC } from "react";

const onBeforePrint = () => {
    const lazySizes = (window as any).lazySizes;
    const imageElements = lazySizes.elements;
    Array.prototype.forEach.call(imageElements, element => {
        lazySizes.loader.unveil(element);
        const lazyImagePlaceholder = element.previousElementSibling;
        if (lazyImagePlaceholder) {
            lazyImagePlaceholder.setAttribute(
                "style",
                "display: flex;align-items:center;justify-content:center;opacity:1",
            );
            lazyImagePlaceholder.innerHTML = translate("Loading...");
        }
    });
};

const onAfterPrint = () => {
    const imagePlaceholders = document.querySelectorAll(".LazyImage-Placeholder");
    imagePlaceholders?.forEach(element => {
        if (element.innerHTML === translate("Loading...")) {
            element.innerHTML = "";
            element.removeAttribute("style");
        }
    });
};

const PrintService: FC<any> = () => {
    React.useEffect(() => {
        window.addEventListener("beforeprint", onBeforePrint);
        window.addEventListener("afterprint", onAfterPrint);
        return () => {
            window.removeEventListener("beforeprint", onBeforePrint);
            window.removeEventListener("afterprint", onAfterPrint);
        };
    }, []);

    return null;
};

export default PrintService;
